import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {LogsDto} from 'libs/shared-models/gtpl/src/lib/logs/logs.dto';

export class LogsResponseModel extends GlobalResponseObject {
    data?:LogsDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LogsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}